/**
 *
 * @param {Coordinate} coordinate
 *
 * @returns {Image}
 */
export default function getCoordinateCoverImage(coordinate) {
  if (!coordinate) {
    return null;
  }
  const coverOrFirstImage = (images => images.find(image => image.isCover) || images[0])(coordinate.images || []);
  if (coverOrFirstImage && coverOrFirstImage.titlePicture) {
    return coverOrFirstImage;
  } else {
    window.console.error('No image src found for coordinate', coordinate);
    return null;
  }
}
